import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';

export default class AnonymousWarningModal extends Modal {
    className() {
        return 'AnonymousWarningModal';
    }

    title() {
        return app.translator.trans(
            'roglo-anonymous-warning.forum.modal.title'
        );
    }

    content() {
        const t = (key) =>
            app.translator.trans(
                'roglo-anonymous-warning.forum.modal.' + key
            );

        return (
            <div className="Modal-body">

                <p className="AnonymousWarningModal-intro">
                    {t('intro')}
                </p>

                <p>
                    <strong>{t('rules_title')}</strong>
                </p>

                <ul className="AnonymousWarningModal-rules">
                    <li>{t('rule_courtesy')}</li>
                    <li>{t('rule_living')}</li>
                    <li>{t('rule_sensitive')}</li>
                    <li>{t('rule_context')}</li>
                    <li>{t('rule_sources')}</li>
                </ul>

                <p className="AnonymousWarningModal-reminder">
                    <strong>{t('reminder')}</strong>
                </p>

                <p className="AnonymousWarningModal-account">
                    {t('account')}
                </p>

                <div className="AnonymousWarningModal-buttons">

                    <Button
                        className="Button"
                        onclick={() => app.modal.close()}
                    >
                        {t('cancel')}
                    </Button>

                    <Button
                        className="Button Button--primary"
                        onclick={() => {
                            const confirm = this.attrs.onConfirm;

                            app.modal.close();

                            if (confirm) {
                                confirm();
                            }
                        }}
                    >
                        {t('confirm')}
                    </Button>

                </div>

            </div>
        );
    }
}
